import React, { FunctionComponent } from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Button } from '..';
import { ModalWrapper, ModalInner } from './modal-styled-components';
import { ReactComponent as Icon } from '../../assets/icon-bang.svg';

export interface ConfirmModalProps {
  show: boolean;
  onConfirm?: (payload?: any) => void;
  onCancel?: () => void;
  title?: string;
  detail?: string;
  confirmText?: string;
  cancelText?: string;
  payload?: any;
}

const iconColor = theme('mode', {
  light: (props: any) => props.theme.colors.red,
  dark: (props: any) => props.theme.colors.redLight,
});

const IconWrapper = styled(Box)`
  color: ${iconColor};
`;

const ConfirmModal: FunctionComponent<ConfirmModalProps> = ({
  show, onConfirm = () => {}, onCancel = () => {}, title = 'Are you sure?',
  detail = '', confirmText = 'OK', cancelText = 'Cancel', payload,
}: ConfirmModalProps) => (show ? (
  <ModalWrapper>
    <Box width="500px">
      <ModalInner>
        <Flex width="100%" height="100%" flexDirection="column">
          <Box flex={1} pb={6}>
            <Flex alignItems="center" mb={3}>
              <IconWrapper mr={2} height="24px">
                <Icon />
              </IconWrapper>
              <Box flex={1}>
                <Text variant="h2" fontWeight={700}>{title}</Text>
              </Box>
            </Flex>
            <Box><Text variant="primary">{detail}</Text></Box>
          </Box>
          <Flex justifyContent="flex-end">
            <Box mr={2}>
              <Button data-testid="confirm-modal-cancel-button" onClick={onCancel} variant="tertiary">{cancelText}</Button>
            </Box>
            <Box mr={2}>
              <Button data-testid="confirm-modal-confirm-button" onClick={() => onConfirm(payload)} variant="primary" isFocused>{confirmText}</Button>
            </Box>
          </Flex>
        </Flex>
      </ModalInner>
    </Box>
  </ModalWrapper>
) : null);

export default ConfirmModal;
